<template>
  <div 
    class="page content" 
    :class="activePage.bg"
  >
    <div class="china"></div>

    <div class="prevpage">
      <div class="icons">
        <div class="icon1 rotatel"></div>
        <div class="icon2 rotater"></div>
        <div class="icon3 rotatel"></div>
        <div class="icon4 rotater"></div>
      </div>
      <div class="text" :style="{top: textTop + 'rem'}">
        <div>“伟大梦想不是等得来、喊得来的<span style="opacity: 0;">”</span></div>
        <div><span style="opacity: 0;">“</span>而是<span>拼</span>出来、干出来的”</div>
        <div style="opacity: 0;">空格</div>
        <div>“十四五”蓝图已绘就</div>
        <div>我们一起动手<span>“拼”</span>出未来！</div>
      </div>
      <div
        class="btn"
        :style="{top: startBtnTop + 'rem'}"
        @click="start"
      ></div>
    </div>

    <!-- 碎片区域 -->
    <div 
      class="pieces-box" 
      :class="{'pieces-animating': piecesAnimating}"
      :style="{top: piecesTop + 'rem'}"
    >
      <div
        class="pieces" 
        v-for="(item, index) in activePiece.pieces" 
        :key="index"
        :style="{'background-color': item.color, 'clip-path': `polygon(${item.point1.x}px ${item.point1.y}px, ${item.point2.x}px ${item.point2.y}px, ${item.point3.x}px ${item.point3.y}px)`, '-webkit-clip-path': `polygon(${item.point1.x}px ${item.point1.y}px, ${item.point2.x}px ${item.point2.y}px, ${item.point3.x}px ${item.point3.y}px)`}"
      />
    </div>
    
    <!-- 切换按钮 -->
    <div class="page-btn routex" :style="{top: pageBtnTop + 'rem'}">
      <div
        v-show="pageIndex > 1"
        class="prev-page"
        @click.stop="prevPage"
      />
      <div
        class="next-page"
        @click.stop="nextPage"
      />
    </div>

    <!-- 摘条文字 -->
    <div
      class="text145"
      :style="{bottom: box145Botttom + 'rem'}"
    >
      <div class="title">
        {{ activePageText.keyword }}
      </div>

      <!-- <div class="text">{{ activePageText.quotoText }}</div> -->
      <div class="text">
        <div v-for="(text, index) in activePageText.quotoText" :key="index"><div class="circle"></div>{{text}}</div>
      </div>
    </div>

    <!-- 我要拼按钮 -->
    <div
      class="nextbtn"
      :class="{'nextbtn-p': nextbtnPushed}"
      :style="{bottom: btnBottom + 'rem'}"
      @touchstart="nextbtnstart"
      @touchend="nextbtnend"
      @click.stop="nextPage"
    ></div>

    <!-- 人大横条 -->
    <div 
      class="renda-box" 
      :class="{'renda-box-open': openBox, 'renda-box-playing': playerPlaying}"
      :style="{height: openBox ? rendaHeight + 'rem' : ''}"
    >
      <div 
        class="shadow" 
        @click="closeRenda"
      />

      <div class="renda">
        <div
          class="head"
          :style="{'background-image': 'url(' + this.$config.publicPath + 'img/heads/' + activePage.head + ')'}"
        />

        <div class="title">{{ activePage.title }}</div>

        <div class="title2">{{ activePage.title2 }}</div>

        <div 
          class="player"
          @click="clickAudioBtn"
        >
          <div class="player-icon-0"></div>
          <div class="player-icon-1"></div>
          <div class="player-icon-2"></div>
          <div class="player-text-box">
            <div class="player-text">话蓝图</div>
          </div>
        </div>

        <div 
          class="btn" 
          @click.stop="rendaClick"
        >
          <div class="btn1"></div>
          <div class="btn2"></div>
          <div class="btn3"></div>
        </div>

        <div class="desc">
          {{ activePage.desc }}
        </div>

        <div
          class="text"
          :style="{height: rendaTextHeight + 'rem'}"
        >
          <div v-for="(t, i) in activePage.text" :key="i">{{t}}</div>
        </div>
      </div>
    </div>

    <!-- 预加载 -->
    <div
      class="preload"
      v-if="preloadNextPage"
    >
      <div :class="preloadNextPage.bg" />
    </div>
  </div>
</template>

<script>
// import tools from '../tools/index'
import piecesData from '../piecesData.js'

export default {
  name: 'Content',
  data: function ()  {
    return {
      // 位置
      textTop: 0,
      startBtnTop: 0,
      piecesTop: 0,
      pageBtnLeftTop: 0,
      pageBtnRightTop: 0,
      box145Botttom: 0,
      btnBottom: 0,
      rendaHeight: 10,
      rendaTextHeight: 5,

      piecesData,

      // 碎片区域的尺寸
      wrapperSize: 0,

      // 图形索引
      // pieces: [],
      piecesIndex: 0,

      // 页面索引
      pageIndex: 0,

      // 当前页面的摘条文字
      activePageText: {
        keyword: '',
        quotoText: ''
      },

      nextbtnPushed: false,

      isVideo: location.href.indexOf('?video') >= 0,

      // showTouchHandler: false,
      // 是否正在翻页，翻页的时候，不能再翻页了
      isPageChanging: false,

      // 图形是否正在动画
      piecesAnimating: false,

      piecesAnimTimeout: [],

      // 是否打开人大条
      openBox: false,
      
      // 是否在播放音频
      playerPlaying: false
    }
  },
  computed: {
    activePiece () {
      const data = this.piecesData[this.piecesIndex]
      // console.log(this.piecesIndex, data)
      return data
    },
    activePage () {
      const data = this.piecesData[this.pageIndex]
      return data
    },
    preloadNextPage () {
      let data
      if (this.pageIndex + 1 < this.piecesData.length) {
        data = this.piecesData[this.piecesIndex + 1]
      }
      
      // console.log(this.pageIndex, data)
      return data
    }
  },
  watch: {
    // 如果当前的piece变了，要初始化动画方法，
    activePiece () {
      console.log('activePiece 变化了, 新值', this.piecesIndex)
      
      const piecesAll = document.querySelectorAll('.pieces')
      for (let i = 0; i< piecesAll.length; i++) {
        piecesAll[i].style.transitionDuration = ''
        piecesAll[i].style.webkitTransitionDuration = ''
      }

      if (this.piecesIndex === 0) {
        // 清理所有动画定时器
        console.log('碎片分开')
        this.clearAllTimeout()

        // 取消是否动画中
        this.piecesAnimating = false
      } else {
        // 调用piece动画
        console.log('碎片合起来，调用动画')
        
        this.piecesAnimateTimer = window.setTimeout(() => {
          // console.log('123123')
          this.pieceAnimate()
        }, 2000)
      }
    },

    activePage () {
      console.log('activepage 变化了, 新值', this.pageIndex)
      
      // 延迟 500ms 再更换文字
      setTimeout(() => {
        this.activePageText.keyword = this.activePage.keyword
        this.activePageText.quotoText = this.activePage.quotoText
      }, 500)
    }
  },

  components: {
    // HelloWorld
  },

  beforeMount () {
    // 计算位置
    const windowHeight = window.innerHeight / window.innerWidth * 20
    
    // this.textTop = (16 + (windowHeight - 24) * 0.5).toFixed(2)
    this.textTop = (13.6 + (windowHeight - 24) * 0.6).toFixed(2)
    this.startBtnTop = (20 + (windowHeight - 24) * 0.8).toFixed(2)

    this.piecesTop = ((windowHeight - 24) * 0.4 - 5).toFixed(2)
    this.pageBtnTop = ((windowHeight - 24) * 0.4 - 5 + 8.6).toFixed(2)
    this.box145Botttom = ((windowHeight - 24) * 0.26 + 4.4).toFixed(2)
    this.btnBottom = ((windowHeight - 24) * 0.12 + 4.4).toFixed(2)

    this.rendaHeight = (Number(this.box145Botttom) + 9.2).toFixed(2)
    this.rendaTextHeight = (Number(this.rendaHeight) - 4.11).toFixed(2)
    // console.log(this.rendaHeight, this.rendaTextHeight)
  },

  mounted () {
    console.log('content mounted')
    this.wrapperSize = document.querySelector('.pieces-box').clientHeight

    // 默认碎片的index
    // this.piecesIndex = 1

    // 初始化音频组件，碎片切换音效
    this.player = document.createElement('audio')
    this.player.autoplay = 'autoplay'
    this.player.addEventListener('ended', () => {
      this.playerPlaying = false
      this.player.currentTime = 0
      // console.log('声音播放完了')
    })

    if (window._czc) {
      let tagname = ''
      if (location.href.indexOf('/2021pieces-tx') >= 0) {
        tagname += '-tx'
      }
      window._czc.push(['_trackEvent', '2021两会策划' + tagname + '-碎片页', 'pv', '','',''])
    }
  },

  beforeDestroy () {
    // 清理所有定时器
    this.clearAllTimeout()
  },

  methods: {
    test () {
      console.log(1)
    },

    // 开始按钮，我来拼
    start () {
      document.querySelector('.renda-box').style.bottom = '0rem'
      document.querySelector('.prevpage').style.opacity = '0'
      
      setTimeout(() => {
        document.querySelector('.prevpage').style.display = 'none'

        document.querySelector('.pieces-box').style.zIndex = '2'
      }, 1500) 

      this.piecesIndex ++
      this.pageIndex ++

      if (window._czc) {
        let tagname = ''
        if (location.href.indexOf('/2021pieces-tx') >= 0) {
          tagname += '-tx'
        }
        window._czc.push(['_trackEvent', '2021两会策划' + tagname + '-内容页', 'pv', '','',''])
      }

      // if (!this.isVideo) {
      // } else {
      //   setTimeout(() => {
      //     this.piecesIndex ++
      //     this.pageIndex ++

      //     let pageLength = 11
      //     let pageAuto = setInterval(() => {
      //       pageLength--

      //       this.nextPage()
      //       if (pageLength === 0) {
      //         clearInterval(pageAuto)
      //       }
      //     }, 10000)
      //   }, 2000)
      // }
    },

    // 清理所有定时器
    clearAllTimeout () {
      window.clearTimeout(this.piecesAnimateTimer)
      window.clearInterval(this.piecesAnimInterval)

      this.piecesAnimTimeout.forEach(item => {
        window.clearTimeout(item)
      })
    },

    // 页面翻页函数
    pageChange (direction) {
      if (this.isPageChanging) return false
      this.isPageChanging = true

      const isPrev = direction === 'prev' && this.piecesIndex > 1
      const isNext = direction === 'next' && this.piecesIndex < this.piecesData.length - 1
      
      // 是否到升华页
      if (direction === 'next' && this.piecesIndex === this.piecesData.length - 1) {
        this.$emit('nextPage')
      } else if (isPrev || isNext) { // 是否翻页
        const delayTIme = 1500

        // 往前翻页
        if (isPrev) {
          const realIndex = this.piecesIndex
          
          // 碎片立即散开
          this.piecesIndex = 0

          // 碎片散开后，页面翻页，更换背景，文字，代表信息
          setTimeout(() => {
            // 页面翻页
            this.pageIndex --

            // 文字翻页动画
            this.prevPageText()
          }, delayTIme)

          // 页面翻页完成，再让碎片合起来
          setTimeout(() => {
            this.piecesIndex = realIndex - 1
          }, delayTIme + 1000)

          // 碎片合起来后，翻页完成
          setTimeout(() => {
            this.isPageChanging = false
          }, delayTIme + 1000 + 1500)
        }

        // 往后翻页
        if (isNext) {
          const realIndex = this.piecesIndex

          // 碎片立即散开
          this.piecesIndex = 0

          // 碎片散开后，页面翻页，更换背景，文字，代表信息
          setTimeout(() => {
            this.pageIndex ++

            // 文字翻页动画
            this.nextPageText()
          }, delayTIme)

          // 页面翻页完成，再让碎片合起来
          setTimeout(() => {
            this.piecesIndex = realIndex + 1
          }, delayTIme + 1000)

          // 碎片合起来后，翻页完成
          setTimeout(() => {
            this.isPageChanging = false
          }, delayTIme + 1000 + 1500)
        }
      }

      if (window._czc) {
        let tagname = ''
        if (location.href.indexOf('/2021pieces-tx') >= 0) {
          tagname += '-tx'
        }
        window._czc.push(['_trackEvent', '2021两会策划' + tagname + '-内容页-' + (this.pageIndex + 1), 'pv', '','',''])
      }
    },

    prevPage () {
      this.pageChange('prev')
    },

    nextPage () {
      this.pageChange('next')
    },

    nextbtnstart () {
      if (!this.isPageChanging) this.nextbtnPushed = true
    },

    nextbtnend () {
      setTimeout(() => {
        this.nextbtnPushed = false
      }, 200)
    },

    // 翻页的时候，给文字添加动画
    prevPageText () {
      document.querySelector('.text145').classList.add('text145animl')

      setTimeout(() => {
        document.querySelector('.text145').classList.remove('text145animl')
      }, 1100)
    },

    nextPageText () {
      document.querySelector('.text145').classList.add('text145animr')

      setTimeout(() => {
        document.querySelector('.text145').classList.remove('text145animr')
      }, 1100)
    },

    // 碎片的小动画，循环播放
    pieceAnimate () {
      this.piecesAnimating = true
      
      // 下一个动画碎片的延迟时间
      let delay

      this.piecesAnimTimeout = []

      const animFunc = function () {
        delay = 0

        this.activePiece.animate.forEach((animate) => {
          const duration = animate.duration
          delay += animate.delay 

          this.piecesAnimTimeout.push(window.setTimeout(() => {
            animate.pieces.forEach(item => {
              const p = item.piece

              document.querySelectorAll('.pieces')[item.index].style.clipPath = `polygon(${p.point1.x}px ${p.point1.y}px, ${p.point2.x}px ${p.point2.y}px, ${p.point3.x}px ${p.point3.y}px)`
              document.querySelectorAll('.pieces')[item.index].style.backgroundColor = item.piece.color
              document.querySelectorAll('.pieces')[item.index].style.transitionDuration = `${duration}ms, ${duration}ms, ${duration}ms`
              document.querySelectorAll('.pieces')[item.index].style.webkitTransitionDuration = `${duration}ms, ${duration}ms, ${duration}ms`
            })
          }, delay))

          delay += duration
        })
      }.bind(this)
      
      animFunc()
      this.piecesAnimInterval = window.setInterval(() => {
        animFunc()
      }, delay)
    },

    // 人大条按钮事件
    rendaClick () {
      this.openBox = !this.openBox
      if (this.openBox) {
        this.openRenda()
      } else {
        this.closeRenda()
      }
    },

    openRenda () {
      this.openBox = true
      // this.playAudio()
    },

    closeRenda () {
      this.openBox = false
      this.pausAudio()
    },

    // 点击播放音频按钮
    clickAudioBtn () {
      if (this.player && this.openBox) {
        if (this.player.paused) {
          this.playAudio()
        } else {
          this.pausAudio()
        }
      }
    },

    playAudio () {
      // console.log(this.player.src , this.$config.publicPath + 'media/' + this.activePiece.audio)
      if (!this.player.src || this.player.src.indexOf(this.$config.publicPath + 'media/' + this.activePiece.audio) < 0) {
        this.player.src = this.$config.publicPath + 'media/' + this.activePiece.audio
      }
      // console.log(this.activePiece.audio)
      this.playerPlaying = true
      this.player.play()
    },

    pausAudio () {
      this.player.pause()
      this.playerPlaying = false
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  background-color: #ffffff;
  background-size: 100% auto;
  background-position: 50% 0;
  background-repeat: no-repeat;
  transition: background-image 1s ease;
  -webkit-transition: background-image 1s ease;

  /* 三角图形区域 */
  .pieces-box {
    position: absolute;
    top: -4rem;
    left: 0rem;
    // z-index: 2;
    z-index: 30;

    width: 20rem;
    height: 20rem;
    // border: solid 1px #000;
    .pieces {
      position: absolute;
      top: 0;
      left: 0;
      width: 20rem;
      height: 20rem;

      transition: background-color .5s ease-out, clip-path .5s ease-out, transform .1s ease-out;
      -webkit-transition: background-color .5s ease-out, -webkit-clip-path .5s ease-out, -webkit-transform .1s ease-out;
    }

    // 30个碎片
    $elements: 31;
    @for $i from 0 to $elements {
      .pieces:nth-child(#{$i}) {
        transition-delay: $i/45 * 1s, $i/30 * 1s, 0s;
        -webkit-transition-delay: $i/45 * 1s, $i/30 * 1s, 0s;
      }
    }
  }

  // 动画中的碎片，延迟为0
  .pieces-animating {
    $elements: 31;
    @for $i from 0 to $elements {
      .pieces:nth-child(#{$i}) {
        transition-delay: 0s;
        -webkit-transition-delay: 0s;
        transition-timing-function: ease,ease,ease;
        -webkit-transition-timing-function: ease,ease,ease;
      }
    }
  }

  .prevpage {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 20;

    width: 100%;
    height: 100%;
    background-color: #ffffff;

    transition: all .5s ease;
    -webkit-transition: all .5s ease;

    .text {
      position: absolute;
      left: 0;

      width: 100%;
      text-align: center;
      line-height: 1.2rem;
      font-size: .75rem;
      color: #C16100;

      & div:nth-child(-n + 3) {
        font-weight: bold;
        font-size: .9rem;
        span {
          font-size: .9rem;
        }
      }
      span {
        font-weight: bold;
        font-size: 1rem;
      }
    }
    .btn {
      position: absolute;
      left: 5.54rem;

      width: 8.93rem;
      height: 2.67rem;
      background-image: url(../assets/startbtn.png);
      background-size: 100%;
      background-repeat: no-repeat;
    }
    .icons {
      & > div {
        position: absolute;
        background-size: 100%;
        background-repeat: no-repeat;
      }
      .icon1 {
        top: 2rem;
        right: -1rem;

        width: 3.57rem;
        height: 3.41rem;
        background-image: url(../assets/content/polygon_1.png);
      }
      .icon2 {
        left: -.3rem;
        bottom: 1rem;

        width: 2.29rem;
        height: 4.43rem;
        background-image: url(../assets/content/polygon_2.png);
      }
      .icon3 {
        top: 4rem;
        left: -1rem;

        width: 5.84rem;
        height: 5.49rem;
        background-image: url(../assets/content/polygon_3.png);
      }
      .icon4 {
        right: -1.2rem;
        bottom: 8rem;

        width: 4.29rem;
        height: 4.91rem;
        background-image: url(../assets/content/polygon_4.png);
      }
    }
  }

  // 翻页的按钮
  .page-btn {
    position: absolute;
    z-index: 3;
    width: 100%;
    transform-origin: 50% 1.36rem;
    -webkit-transform-origin: 50% 1.36rem;

    .prev-page, .next-page {
      position: absolute;
      top: 0;
      z-index: 3;
      width: 2.72rem;
      height: 2.72rem;
      // background-color: #F56C6C;
      background-image: url(../assets/icons/button_le_black_nor@2x.png);
      background-size: 1.04rem 1.07rem;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      transition: background-image 1s ease;
      -webkit-transition: background-image 1s ease;
    }
    .prev-page {
      left: 0;
    }
    .next-page {
      right: 0;
      transform: rotate(180deg);
      -webkit-transform: rotate(180deg);
    }
  }

  // 十四五摘条文字
  .text145 {
    position: absolute;
    bottom: 4rem;
    z-index: 4;

    margin: 0 1.44rem;
    width: 17.1734rem;

    transition: opacity ease .5s;
    // min-height: 8.96rem;
    .title {
      text-align: left;
      line-height: 1.92rem;
      font-family: 'title';
      font-size: 1.5rem;
      transition: color 1s ease;
      -webkit-transition: color 1s ease;
    }
    .text {
      margin-top: .24rem;
      height: 8.96rem;
      // white-space: pre;
      text-align: left;
      line-height: 1.12rem;
      font-size: .75rem;
      transition: color 1s ease;
      -webkit-transition: color 1s ease;

      div {
        position: relative;

        .circle {
          position: absolute;
          top: .45rem;
          left: -.45rem;

          margin: 0;
          border: solid 2px #000000;
          border-radius: 100%;
          width: 0;
          height: 0;
        }
      }
    }
  }

  .nextbtn {
    position: absolute;
    left: 5.935rem;
    bottom: 4rem;
    z-index: 7;
    
    width: 8.13rem;
    height: 1.89rem;
    background-image: url(../assets/content/but_content_nor.png);
    background-size: 100%;
    background-repeat: no-repeat;
  }
  .nextbtn-p {
    background-image: url(../assets/content/but_content_sel.png);
  }

  // 滑动切换页面事件
  .touch-handler {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 6;
    width: 100%;
    height: 100%;
  }

  /* 底部人大浮动条 */
  .renda-box {
    position: fixed;
    left: 0;
    bottom: -5rem;
    z-index: 10;

    width: 100%;
    height: 4.4rem;
    overflow: hidden;
    box-shadow: black 0px 15px 30px 0px;
    background-color: #ffffff;
    text-align: left;

    transition: all .5s ease;
    -webkit-transition: all .5s ease;

    .shadow {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 11;
      width: 100vw;
      height: 100vh;
      // background-color: rgba(0, 0, 0, .5);
      opacity: 0;
      transition: opacity 1s linear;
      -webkit-transition: opacity 1s linear;
    }

    .renda {
      position: absolute;
      top: 0;
      z-index: 12;
      margin: 0.53rem 1.44rem 0;
      width: 17.12rem;
      height: 3.2rem;

      .head {
        position: absolute;
        top: 0;
        left: 0;
        border-radius: .32rem;
        width: 1.44rem;
        height: 1.44rem;
        // background-color: #E6A23C;
        background-size: 100%;

        transition: background-image ease 1s;
        -webkit-transition: background-image ease 1s;
      }

      .title {
        position: absolute;
        top: .4rem;
        left: 1.87rem;
        // width: 10rem;
        width: 13.1rem;
        line-height: 1.3;
        font-size: .59rem;
        color: rgba(0, 0, 0, 0.6);
        transition: top .3s linear, width .3s linear;
        -webkit-transition: top .3s linear, width .3s linear;
      }

      .title2 {
        // display: flex;
        // display: -webkit-flex;
        // flex-direction: column;
        // justify-content: center;

        position: absolute;
        top: 0;
        left: 1.87rem;
        width: 8.5rem;
        height: 1.44rem;
        line-height: .72rem;
        font-size: .55rem;
        color: rgba(0, 0, 0, 0.6);
        
        opacity: 0;
        
        transition: top .3s linear, opacity .3s linear;
        -webkit-transition: top .3s linear, opacity .3s linear;
      }

      .desc {
        position: absolute;
        top: 1.4rem;
        // top: 1.58rem;
        left: 1.87rem;
        width: 13.1rem;
        
        line-height: 1.2;
        font-weight: 400;
        font-size: .725rem;
        color: rgba(0, 0, 0, 0.85);
        transition: opacity .5s linear;
        -webkit-transition: opacity .5s linear;
      }

      .btn {
        position: absolute;
        top: -.5rem;
        right: -.5rem;
        padding: .5rem;
        width: .4267rem;
        height: .8533rem;
        
        transition: all ease .5s;
        -webkit-transition: all ease .5s;

        .btn1 {
          position: absolute;
          top: .5rem;
          left: .5rem;

          width: .4267rem;
          height: .4267rem;

          background-image: url(../assets/icons/icon_up_nor@2x.png);
          background-position: 50% 0%;
          background-size: .43rem .86rem;
          background-repeat: no-repeat;

          animation: fade 1.5s linear 1s both infinite;
          -webkit-animation: fade 1.5s linear 1s both infinite;
        }
        .btn2 {
          position: absolute;
          left: .5rem;
          bottom: .5rem;

          width: .4267rem;
          height: .4267rem;

          background-image: url(../assets/icons/icon_up_nor@2x.png);
          background-position: 50% 100%;
          background-size: .43rem .86rem;
          background-repeat: no-repeat;

          animation: fade 1.5s linear .5s both infinite;
          -webkit-animation: fade 1.5s linear .5s both infinite;
        }
        .btn3 {
          position: absolute;
          left: .5rem;
          bottom: -.0733rem;

          width: .4267rem;
          height: .4267rem;

          background-image: url(../assets/icons/icon_up_nor@2x.png);
          background-position: 50% 100%;
          background-size: .43rem .86rem;
          background-repeat: no-repeat;

          animation: fade 1.5s linear both infinite;
          -webkit-animation: fade 1.5s linear both infinite;
        }
      }

      .player {
        position: absolute;
        top: -.1333rem;
        right: 1.4667rem;
        width: 4.1336rem;
        height: 2.1334rem;
        // background-color: #E6A23C;
        background-image: url(../assets/icons/but_bg_yellow@2x.png);
        background-size: 100%;
        
        opacity: 0;
        transition: opacity .3s linear;
        -webkit-transition: opacity .3s linear;

        .player-icon-0 {
          position: absolute;
          top: .44rem;
          left: .8rem;
          width: .8rem;
          height: .8rem;
          background-image: url(../assets/icons/icon_sound_0@2x.png);
          background-size: 100%;
        }
        .player-icon-1 {
          position: absolute;
          top: .44rem;
          left: .8rem;
          width: .8rem;
          height: .8rem;
          background-image: url(../assets/icons/icon_sound_1@2x.png);
          background-size: 100%;
        }
        .player-icon-2 {
          position: absolute;
          top: .44rem;
          left: .8rem;
          width: .8rem;
          height: .8rem;
          background-image: url(../assets/icons/icon_sound_2@2x.png);
          background-size: 100%;
        }
        .player-text-box {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;

          position: absolute;
          top: .23rem;
          left: 1.7rem;
          height: 1.26rem;

          .player-text {
            background-image: url(../assets/icons/textbg.png);
            background-size: 100% 100%;
            background-position: 0 50%;
            background-clip: text;
            -webkit-background-clip: text;

            text-align: center;
            line-height: 1;
            font-size: .56rem;
            color: transparent;

            font-size: 1.26rem;
            width: 3em;
            transform: scale(.44);
            transform-origin: 0 50%;
          }
        }
      }
      .text {
        position: absolute;
        top: 2.08rem;
        left: 0;

        width: 17.12rem;
        height: 5.89rem;
        overflow-y: auto;

        // white-space: pre-wrap;
        text-indent: 2em;
        line-height: 1.57;
        font-weight: 400;
        font-size: .75rem;
        color: rgba(0, 0, 0, 0.85);
        opacity: 0;

        transition: opacity .5s linear .25s;
        -webkit-transition: opacity .5s linear .25s;
      }
    }
  }

  // 打开状态
  .renda-box-open {
    overflow: initial;
    // height: 10rem;
    height: 15.86rem;
    .shadow {
      opacity: 1;
    }
    .renda {
      .title {
        opacity: 0;;
        // top: .4rem;
        // width: 10rem;
      }
      .title2 {
        // top: 0;
        opacity: 1;
      }
      .desc {
        opacity: 0;
      }
      .player {
        opacity: 1;
      }
      .text {
        opacity: 1;
      }
      .btn {
        transform: rotateY(180deg);
        -webkit-transform: rotateY(180deg);
        
        .btn1, .btn2, .btn3{
          background-image: url(../assets/icons/icon_down_nor@2x.png);
        }
      }
    }
  }
  
  // 播放状态
  .renda-box-playing {
    .renda {
      .player {
        .player-icon-1 {
          animation: sound 1s linear infinite both;
          -webkit-animation: sound 1s linear infinite both;
        }
        .player-icon-2 {
          animation: sound 1s linear .25s infinite both;
          -webkit-animation: sound 1s linear .25s infinite both;
        }
        .player-text {
          animation: playertext 1s linear infinite;
          -webkit-animation: playertext 1s linear infinite;
        }
      }
    }
  }
}

// 背景图片
// 5G，通讯
.bg_communication {
  background-image: url(../assets/bgs/bg_communication.png);
  .title, .text {
    color: rgb(130, 91, 46)
  }
  .text145 .text div.circle {
    border-color: rgb(130, 91, 46);
  }
}

// 交通，高铁
.bg_traffic {
  background-image: url(../assets/bgs/bg_traffic.png);
  .title, .text {
    color: rgb(61, 110, 184)
  }
  .text145 .text div.circle {
    border-color: rgb(61, 110, 184);
  }
}

// 文化，脸谱
.bg_culture {
  background-image: url(../assets/bgs/bg_culture.png);
  .title, .text {
    color: rgb(153, 76, 71)
  }
  .page-btn {
    .prev-page, .next-page {
      background-image: url(../assets/icons/button_le_withe_nor@2x.png);
    }
  }
  .text145 .text div.circle {
    border-color: rgb(153, 76, 71);
  }
}

// 就业，证件照
.bg_job {
  background-image: url(../assets/bgs/bg_job.png);
  .title, .text {
    color: rgb(86, 55, 36)
  }
  .page-btn {
    .prev-page, .next-page {
      // 纯白
      background-image: url(../assets/icons/button_le_withe_sel@2x.png);
    }
  }
  .text145 .text div.circle {
    border-color: rgb(86, 55, 36);
  }
}

// 教育
.bg_education {
  background-image: url(../assets/bgs/bg_education.png);
  .title, .text {
    color: rgb(102, 52, 12)
  }
  .page-btn {
    .prev-page, .next-page {
      background-image: url(../assets/icons/button_le_withe_nor@2x.png);
    }
  }
  .text145 .text div.circle {
    border-color: rgb(102, 52, 12);
  }
}

// 科技创新
.bg_science {
  background-image: url(../assets/bgs/bg_science.png);
  .title, .text {
    color: rgb(68, 116, 164)
  }
  .renda-box .renda .title2 {
    width: 8rem;
  }
  .page-btn {
    .prev-page, .next-page {
      background-image: url(../assets/icons/button_le_withe_nor@2x.png);
    }
  }
  .text145 .text div.circle {
    border-color: rgb(68, 116, 164);
  }
  
  $elements1: 16;
  @for $i from 0 to $elements1 {
    .pieces-animating .pieces:nth-child(#{$i}) {
      transform-origin: 13.5rem 12.5rem;
      -webkit-transform-origin: 13.5rem 12.5rem;
      animation: head 5s ease both infinite;
      -webkit-animation: head 5s ease both infinite;
    }
  }

  $elements2: 31;
  @for $i from 18 to $elements2 {
    .pieces-animating .pieces:nth-child(#{$i}) {
      transform-origin: 13.5rem 12.5rem;
      -webkit-transform-origin: 13.5rem 12.5rem;
      animation: head 5s ease both infinite;
      -webkit-animation: head 5s ease both infinite;
    }
  }
}

// 养老
.bg_pension {
  background-image: url(../assets/bgs/bg_pension.png);
  .title, .text {
    color: rgb(106, 106, 52)
  }
  .text145 .text div.circle {
    border-color: rgb(106, 106, 52);
  }
}

// 健康中国，医疗
.bg_medical {
  background-image: url(../assets/bgs/bg_medical.png);
  .title, .text {
    color: rgb(255, 255, 255)
  }
  .renda-box .renda .title2 {
    width: 8rem;
  }
  .page-btn {
    .prev-page, .next-page {
      background-image: url(../assets/icons/button_le_withe_nor@2x.png);
    }
  }
  .text145 .text div.circle {
    border-color: rgb(255, 255, 255);
  }

  $elements2: 31;
  @for $i from 23 to $elements2 {
    .pieces-animating .pieces:nth-child(#{$i}) {
      animation: boxmove 5s ease both infinite;
      -webkit-animation: boxmove 5s ease both infinite;
    }
  }
}

// 消费，购物车
.bg_shopping {
  background-image: url(../assets/bgs/bg_shopping.png);
  .title, .text {
    color: rgb(133, 43, 95)
  }
  .page-btn {
    .prev-page, .next-page {
      background-image: url(../assets/icons/button_le_withe_nor@2x.png);
    }
  }
  .text145 .text div.circle {
    border-color: rgb(133, 43, 95);
  }

  $elements2: 17;
  @for $i from 13 to $elements2 {
    .pieces-animating .pieces:nth-child(#{$i}) {
      animation: bagmove 5s ease both infinite;
      -webkit-animation: bagmove 5s ease both infinite;
    }
  }
}

// 生态
.bg_ecology {
  background-image: url(../assets/bgs/bg_ecology.png);
  .title, .text {
    color: rgb(41, 80, 74)
  }
  .page-btn {
    .prev-page, .next-page {
      background-image: url(../assets/icons/button_le_withe_nor@2x.png);
    }
  }

  @for $i from 26 to 31 {
    .pieces-animating .pieces:nth-child(#{$i}) {
      animation: birdmove 5s ease both infinite;
      -webkit-animation: birdmove 5s ease both infinite;
    }
  }
  .text145 .text div.circle {
    border-color: rgb(41, 80, 74);
  }
}

// // 住房
// .bg_housing {
//   background-image: url(../assets/bgs/bg_housing.png);
//   .title, .text {
//     color: rgb(86, 55, 36)
//   }
//   .page-btn {
//     .prev-page, .next-page {
//       // 纯白
//       background-image: url(../assets/icons/button_le_withe_sel@2x.png);
//     }
//   }
// }

// 乡村建设
.bg_village {
  background-image: url(../assets/bgs/bg_village.png);
  .title, .text {
    color: rgb(186, 137, 52)
  }
  .page-btn {
    .prev-page, .next-page {
      background-image: url(../assets/icons/button_le_withe_sel@2x.png);
    }
  }
  .text145 .text div.circle {
    border-color: rgb(186, 137, 52);
  }
}

// 预加载
.preload {
  position: absolute;
  top: 0;
  left: -2rem;
  width: 1rem;
  height: 1rem;
  overflow: hidden;
}

.video {
  .page-btn, .nextbtn, .renda-box {
    display: none;
  }
  .china {
    position: absolute;
    top: 1rem;
    left: 1rem;

    width: 6rem;
    height: 1.725rem;

    // background-image: url(../assets/china.png);
    background-size: 6rem 1.725rem;
    background-position: 50% 0;
    background-repeat: no-repeat;
  }
}

// 动画
.rotatel {
  animation: rotatel 20s linear infinite;
  -webkit-animation: rotatel 20s linear infinite;
}
@keyframes rotatel {
  0% { transform: rotateZ(0deg); }
  100% { transform: rotateZ(360deg); }
}
@-webkit-keyframes rotatel {
  0% { -webkit-transform: rotateZ(0deg); }
  100% { -webkit-transform: rotateZ(360deg); }
}

.rotater {
  animation: rotater 20s linear infinite;
  -webkit-animation: rotater 20s linear infinite;
}
@keyframes rotater {
  0% { transform: rotateZ(0deg); }
  100% { transform: rotateZ(-360deg); }
}
@-webkit-keyframes rotater {
  0% { -webkit-transform: rotateZ(0deg); }
  100% { -webkit-transform: rotateZ(-360deg); }
}

@keyframes sound {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}
@-webkit-keyframes sound {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes playertext {
  0% { background-position: 0 50%; }
  100% { background-position: 3.78rem 50%; }
}
@-webkit-keyframes playertext {
  0% { background-position: 0 50%; }
  100% { background-position: 3.78rem 50%; }
}

.routex {
  animation: routex 2s ease both infinite;
  -webkit-animation: routex 2s ease both infinite;
}
@keyframes routex {
  0% { transform: rotateX(0deg); }
  50% { transform: rotateX(360deg); }
  100% { transform: rotateX(360deg); }
}
@-webkit-keyframes routex {
  0% { -webkit-transform: rotateX(0deg); }
  50% { -webkit-transform: rotateX(360deg); }
  100% { -webkit-transform: rotateX(360deg); }
}

@keyframes fade {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}
@-webkit-keyframes fade {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

// 科技动画
@keyframes head {
  0% { transform: rotate(0deg); }
  20% { transform: rotate(5deg); }
  30% { transform: rotate(5deg); }
  50% { transform: rotate(-10deg); }
  60% { transform: rotate(-10deg); }
  80% { transform: rotate(0deg); }
  100% { transform: rotate(0deg); }
}
@-webkit-keyframes head {
  0% { -webkit-transform: rotate(0deg); }
  20% { -webkit-transform: rotate(5deg); }
  30% { -webkit-transform: rotate(5deg); }
  50% { -webkit-transform: rotate(-10deg); }
  60% { -webkit-transform: rotate(-10deg); }
  80% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(0deg); }
}

// 医疗动画
@keyframes boxmove {
  0% { transform: translate(0, 0); }
  30% { transform: translate(-.5rem, 0); }
  60% { transform: translate(0, 0); }
  100% { transform: translate(0, 0); }
}
@-webkit-keyframes boxmove {
  0% { -webkit-transform: translate(0, 0); }
  30% { -webkit-transform: translate(-.5rem, 0); }
  60% { -webkit-transform: translate(0, 0); }
  100% { -webkit-transform: translate(0, 0); }
}

// 购物袋动画
@keyframes bagmove {
  0% { transform: translate(0, 0); }
  30% { transform: translate(0, -.4rem); }
  60% { transform: translate(0, 0); }
  100% { transform: translate(0, 0); }
}
@-webkit-keyframes bagmove {
  0% { -webkit-transform: translate(0, 0); }
  30% { -webkit-transform: translate(0, -.4rem); }
  60% { -webkit-transform: translate(0, 0); }
  100% { -webkit-transform: translate(0, 0); }
}

// 生态，小鸟动画
@keyframes birdmove {
  0% { transform: translate(0, 0); }
  30% { transform: translate(.4rem, 0); }
  60% { transform: translate(0, 0); }
  100% { transform: translate(0, 0); }
}
@-webkit-keyframes birdmove {
  0% { -webkit-transform: translate(0, 0); }
  30% { -webkit-transform: translate(.4rem, 0); }
  60% { -webkit-transform: translate(0, 0); }
  100% { -webkit-transform: translate(0, 0); }
}

// 145文字动画
.text145animr {
  animation: text145animr 1s ease;
  -webkit-animation: text145animr 1s ease;
}
.text145animl {
  animation: text145animl 1s ease;
  -webkit-animation: text145animl 1s ease;
}

@keyframes text145animr {
  0%  { transform: translate(0rem, 0);opacity: 1; }
  50% { transform: translate(0rem, 0);opacity: 0; }
  50.1% { transform: translate(20rem, 0); }
  100% { transform: translate(0rem, 0); }
}
@-webkit-keyframes text145animr {
  0%  { transform: translate(0rem, 0);opacity: 1; }
  50% { transform: translate(0rem, 0);opacity: 0; }
  50.1% { -webkit-transform: translate(20rem, 0); }
  100% { -webkit-transform: translate(0rem, 0); }
}

@keyframes text145animl {
  0%  { transform: translate(0rem, 0);opacity: 1; }
  50% { transform: translate(0rem, 0);opacity: 0; }
  50.1% { transform: translate(-20rem, 0); }
  100% { transform: translate(0rem, 0); }
}
@keyframes text145animl {
  0%  { transform: translate(0rem, 0);opacity: 1; }
  50% { transform: translate(0rem, 0);opacity: 0; }
  50.1% { transform: translate(-20rem, 0); }
  100% { transform: translate(0rem, 0); }
}

</style>
